import http from './http-common';

const BASE = '/admin/portal/ga4-purchase-tracking';

// filters: { date_from, date_to, search, page, limit } (all optional)
export const listOrders = async (filters = {}) => {
  return http.get(`${BASE}/orders`, { params: filters });
};

// orderId required; force:true skips the GA4 duplicate check server-side
export const refireOrder = async (orderId, force = false) => {
  return http.post(`${BASE}/refire`, new URLSearchParams({ orderId, force }).toString());
};

export default {
  listOrders,
  refireOrder,
};
